function formatMoney(cents, format) {
  const moneyFormat = '${{amount}}';

  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + thousands
    );
    var centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute(
    'aria-expanded',
    summary.parentNode.hasAttribute('open')
  );

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty(
        '--viewport-height',
        `${window.innerHeight}px`
      );

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
        event,
        this.mainDetailsToggle.querySelector('summary')
      )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
            'transitionend',
            addTrapFocus
          );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle
      .querySelectorAll('.submenu-open')
      .forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset ||
        this.closest('.header-wrapper').classList.contains(
          'header-wrapper--border-bottom'
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add('menu-open');

    this.mainDetailsToggle.classList.add('menu-opening');

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
      this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener('click', this.linkToSlide.bind(this))
    );
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true')
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      'click',
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      'slider-counter__link--active'
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      'aria-current',
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
        this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) +
        1 -
        this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class ProductSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSliders();
  }

  initSliders() {
    const mainSlider = this.querySelector('.main-product-v3__product-slider');
    const thumbnailsSlider = this.querySelector('.main-product-v3__thumbnails');

    if (!mainSlider || !thumbnailsSlider) return;

    this.thumbnailsSlider = new Swiper(thumbnailsSlider, {
      spaceBetween: 3,
      slidesPerView: 7,
      freeMode: true,
      watchSlidesProgress: true,
      direction: 'horizontal',
      breakpoints: {
        1023: { spaceBetween: 4 },
      },
    });

    this.mainSlider = new Swiper(mainSlider, {
      spaceBetween: 10,
      effect: 'fade',
      grabCursor: true,
      thumbs: { swiper: this.thumbnailsSlider },
    });
  }

  updateSliderMedia(selectedMediaId) {
    if (!selectedMediaId) return;

    const slides = this.querySelectorAll('[is-variant-media]');

    slides.forEach((slide) => {
      slide.style.display =
        slide.getAttribute('data-media-id') == selectedMediaId
          ? 'block'
          : 'none';
      slide.classList.toggle(
        'swiper-slide',
        slide.getAttribute('data-media-id') == selectedMediaId
      );
    });

    this.thumbnailsSlider.update();
    this.mainSlider.update();

    this.querySelectorAll(
      '.main-product-v3__product-slide.swiper-slide'
    ).forEach((slide, index) => {
      if (slide.getAttribute('data-media-id') == selectedMediaId) {
        this.mainSlider.slideTo(index);
      }
    });
  }
}

customElements.define('component-swiper-slider', ProductSlider);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.productSlider = document.querySelector('component-swiper-slider');
    this.addEventListener('change', (e) => this.onVariantChange(e));
  }

  connectedCallback() {
    const currentSize = document.querySelector(
      ".main-product-v3__fieldset-input[name='Size']:checked"
    );
    const currentWidth = document.querySelector(
      ".main-product-v3__fieldset-input[name='Width']:checked"
    );
    const currentPack = document.querySelector(
      ".main-product-v3__fieldset-input[name='Pack']:checked"
    );

    this.updateOptions();
    this.updateMasterId();
    this.updatePackPrices();

    if (this.currentVariant) {
      if (this.productSlider) {
        this.productSlider.updateSliderMedia(
          this.currentVariant.featured_media?.id
        );
      }

      if (currentSize) {
        this.updateSizeLabel(currentSize.value);
      }

      if (currentWidth) {
        this.updateWidthLabel(currentWidth.value);
      }

      if (currentPack) {
        this.updatePackSavingLabel(currentPack);
      }

      this.showLowStockAlert(this.currentVariant.id);

      // if (!this.currentVariant.available) {
      //   this.toggleAddButton(
      //     !this.currentVariant.available,
      //     this.currentVariant.available ? "" : window.variantStrings.soldOut
      //   );
      // }
    }
  }

  onVariantChange({ target }) {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      // this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateMeta();
      this.showLowStockAlert(this.currentVariant.id);
      this.updateStickyAtcModal();
      this.updatePrices();
      this.toggleBackInStockBox();

      if (this.productSlider) {
        this.productSlider.updateSliderMedia(
          this.currentVariant.featured_media?.id
        );
      }

      switch (target.getAttribute('name')) {
        case 'Color':
          this.updateColorLabel(target.value);
          break;
        case 'Size':
          this.updateSizeLabel(target.value);
          break;
        case 'Width':
          this.updateWidthLabel(target.value);
          break;
        case 'Pack':
          this.updatePackLabel(target.value);
          this.updatePackSavingLabel(target);
          this.updateFreeShippingLabel(target.value);
          break;
        default:
          this.updateDefaultOptionLabel(target);
          break;
      }
    }

  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMeta() {
    extraVariantInfo(this.currentVariant.id);
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );

    mediaGallery &&
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);

    // Sticky add to cart image
    const stickyImage = document.querySelector('.js-sticky-atc-image');
    if (!stickyImage) return;
    stickyImage.src = this.currentVariant.featured_image.src;
    stickyImage.alt = this.currentVariant.featured_image.alt;
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        // this.toggleAddButton(
        //   !this.currentVariant.available,
        //   window.variantStrings.soldOut
        // );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButtons = productForm.querySelectorAll('[name="add"]');

    addButtons.forEach((addButton) => {
      const addButtonText = addButton.querySelector('span');

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    });

    // Sticky add to cart buttons
    const stickyButtonSoldOut = document.querySelector(
      '.sticky-product-atc .sold-out'
    );
    const stickyAddButton = document.querySelector(
      '.sticky-product-atc add-to-card-plp'
    );

    if (!stickyButtonSoldOut && !stickyAddButton) return;

    if (disable) {
      stickyButtonSoldOut.style.display = 'block';
      stickyAddButton.style.display = 'none';
    } else {
      stickyButtonSoldOut.style.display = 'none';
      stickyAddButton.style.display = 'block';
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateStickyAtcModal() {
    const stickyAtcModal = document.querySelector(
      '.sticky-product-atc add-to-card-plp'
    );
    if (!stickyAtcModal) return;

    const fieldsets = [
      ...stickyAtcModal.querySelectorAll('fieldset.product-form__input'),
    ];
    if (!fieldsets) {
      return;
    } else if (fieldsets.length == 1) {
      fieldsets.forEach((fieldset) => {
        let newValue = this.options[0];

        const labels = [
          ...fieldset.querySelectorAll('.product-form__input-grid label'),
        ];
        if (!labels) return;
        labels.forEach((label) => {
          if (label.dataset.value == newValue) {
            label.click();
          }
        });
      });
    } else if (fieldsets.length == 2) {
      fieldsets.forEach((fieldset) => {
        let newValue;
        if (fieldset.dataset.name == 'Size') {
          newValue = this.options[0];
        } else if (fieldset.dataset.name == 'Color') {
          newValue = this.options[1];
        }
        const labels = [
          ...fieldset.querySelectorAll('.product-form__input-grid label'),
        ];
        if (!labels) return;
        labels.forEach((label) => {
          if (label.dataset.value == newValue) {
            label.click();
          }
        });
      });
    }
  }

  updateColorLabel(value) {
    const textBlock = document.querySelector('.pdp-color-text');
    if (textBlock) textBlock.textContent = value;
  }

  updateWidthLabel(value) {
    const textBlock = document.querySelector(
      '.main-product-v3 .pdp-width-text'
    );
    if (!textBlock) return;
    this.currentWidth = value;
    const key = `${this.currentSize}${value}`;

    const widthText = {
      MediumStandard: 'Calf Measurement (12" - 16")',
      MediumWide: 'Calf Measurement (16" - 20")',
      LargeStandard: 'Calf Measurement (14" - 18")',
      LargeWide: 'Calf Measurement (18" - 22")',
      'X-LargeStandard': 'Calf Measurement (16" - 20")',
      'X-LargeWide': 'Calf Measurement (20" - 24")',
    };

    if (widthText[key]) {
      textBlock.innerText = widthText[key];
    } else {
      textBlock.innerText = value;
    }
  }

  updateSizeLabel(value) {
    let textBlock;
    let sizeText;
    const IsTrades = document.querySelector(
      '.main-product-v3 .pdp-size-text.size-text__trades-socks'
    );

    if (window.customSizeText && Object.keys(window.customSizeText).length > 0) {
      textBlock = document.querySelector('.main-product-v3 .pdp-size-text') || null;
      sizeText = window.customSizeText;
    } else if (IsTrades) {
      textBlock = IsTrades;
      sizeText = {
        Medium: 'Medium (Men 7-9.5 | Women 7-10)',
        Large: 'Large (Men 10-13 | Women 10.5-13)',
        'X-Large': 'X-Large (Men 13-15)',
      };
    } else {
      textBlock =
        document.querySelector('.main-product-v3 .pdp-size-text') || null;
      sizeText = {
        Medium: 'Medium (Men 8-10 | Women 7-10)',
        Large: 'Large (Men 10.5-13 | Women 10.5-12)',
        'X-Large': 'X-Large (Men 13.5-15)',
      };
    }

    if (!textBlock) return;
    this.currentSize = value;

    if (sizeText[value]) {
      textBlock.innerText = sizeText[value];
    } else {
      textBlock.innerText = value;
    }

    if (this.currentWidth) {
      this.updateWidthLabel(this.currentWidth);
    }
  }

  updatePackLabel(value) {
    const packLabel = document.querySelector('.pack-option .form__value');
    const packFieldset = document.querySelector('.pack-option');
    if (!packLabel) return;

    // Check if this is a beanie product
    const isBeanie =
      packFieldset && packFieldset.getAttribute('data-is-beanie') === 'true';
    const name =
      value == 1
        ? isBeanie
          ? 'Beanie'
          : 'Pair'
        : isBeanie
        ? 'Beanies'
        : 'Pairs';

    const pdpQuantity = document.querySelector(
      '#pdp_quantity .quantity__input'
    );

    pdpQuantity.value = +value;
    packLabel.textContent = `${value} ${name}`;
  }

  updatePackSavingLabel(target) {
    const label = document.querySelector('.main-product-v3__saving');
    if (!label) return;
    const percent = +target
      .closest('[data-percent]')
      .getAttribute('data-percent');

    const text = percent ? `${percent}% OFF` : 'BUY 2 GET 2 FREE';
    label.textContent = text;
  }

  updateDefaultOptionLabel(target) {
    if (!target || !target.value) return;

    const value = target.value;
    const wrapper = target.closest('.main-product-v3__fieldset');
    if (!wrapper) return;

    const label = wrapper.querySelector('.main-product-v3__current-option-text');
    if (!label) return;

    label.textContent = value;
  }

  // REMOVED: NEW FREE SHIPPING TIER IS >$95

  // updateFreeShippingLabel(value) {
  //   const label = document.querySelector(
  //     '.main-product-v3__pricing-shipping-label span'
  //   );
  //   if (!label) return;

  //   value >= 4
  //     ? (label.textContent = 'FREE SHIPPING')
  //     : (label.textContent = 'FREE SHIPPING ON ORDERS OVER $95');
  // }

  updatePrices() {
    const quantityInput = document.querySelector("[name='Pack']:checked");
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    const { price, compare_at_price } = this.currentVariant;
    const savingLabel = document.querySelector('.main-product-v3__saving');
    const bundleItemCount =
      parseInt(savingLabel?.dataset.bundleItemCount, 10) || 4;
    let percent = 0;

    if (quantityInput) {
      const closestElement = quantityInput.closest('[data-percent]');
      if (closestElement) {
        percent =
          parseInt(closestElement.getAttribute('data-percent'), 10) || 0;
      }
    }

    const currentTotalPrices = document.querySelectorAll(
      '.main-product-v3__current-price'
    );
    
    const currentTotalSaving = document.querySelectorAll(
      '.main-product-v3__saving span'
    );
    const originalTotalPrices = document.querySelectorAll(
      '.main-product-v3__original-price'
    );

    const discountedPrice = price * (1 - percent / 100) * quantity;
    const discountedPriceSaving = (discountedPrice - 1) / bundleItemCount;

    currentTotalPrices.forEach(
      (item) => (item.textContent = formatMoney(discountedPrice))
    );

    currentTotalSaving.forEach(
      (item) => (item.textContent = formatMoney(discountedPriceSaving))
    );

    // changed from quantity > 1 for bogo launch
    if (quantity > 3) {
      originalTotalPrices.forEach(
        (item) => (item.textContent = formatMoney(price * quantity))
      );
    } else if (quantity == 1 && compare_at_price && compare_at_price > price) {
      originalTotalPrices.forEach(
        (item) => (item.textContent = formatMoney(compare_at_price))
      );
    } else {
      originalTotalPrices.forEach((item) => (item.textContent = ''));
    }

    this.updatePackPrices();
  }

  updatePackPrices() {
    const packPrices = this.querySelectorAll('.main-product-v3__bottom-info');

    if (!packPrices) return;

    const packFieldset = document.querySelector('.pack-option');
    const isBeanie =
      packFieldset && packFieldset.getAttribute('data-is-beanie') === 'true';
    const unitText = isBeanie ? 'BEANIE' : 'PAIR';

    packPrices.forEach((price) => {
      const discount =
        price.closest('[data-percent]').getAttribute('data-percent') || 0;

      const packQty = price.closest('[data-count]').getAttribute('data-count');

      const discountValue = parseFloat(discount);
      if (isNaN(discountValue)) return;

      const discountedPrice = this.currentVariant.price * (1 - discountValue / 100);
      const discountedCents = Math.floor(discountedPrice);

      const formattedPrice = formatMoney(discountedCents, '${{amount}}');

      // free beanie above offer threshold
      if (discountedPrice >= 2499 && packQty == 6) {
        price.innerHTML = `${formattedPrice}/${unitText} + <span>FREE BEANIE</span>`;
      } else {
        price.textContent = `${formattedPrice}/${unitText}`;
      }
    });
  }

  toggleBackInStockBox() {
    const customPlace = document.querySelector('#backInStockCustomPlace');
    const customBox = document.querySelector('#backInStockCustomBox');

    if (customPlace && customBox) {
      const klaviyoButton = customPlace.querySelector('.klaviyo-bis-trigger');

      if (klaviyoButton && getComputedStyle(klaviyoButton).display !== 'none') {
        customBox.style.display = 'block';
      } else {
        customBox.style.display = 'none';
      }
    }
  }


  showLowStockAlert(variantId) {
    const alertEl = document.querySelector('.main-product-v3__low-stock-alert-threshold');
    const alertTotalEl = document.querySelector('.main-product-v3__low-stock-alert-total');

    if (!alertEl) return;
    if (!alertTotalEl) return;

    const jsonEl = document.getElementById('VariantsInventoryJSON');
    if (!jsonEl) return;

    const variants = JSON.parse(jsonEl.textContent);
    const found = variants.find((v) => v.id === variantId);
    if (!found) return;

    // Hotfix for hiding OOS notification
    const threshold = parseInt(alertEl.dataset.threshold, 10);

    if (found.inventory_quantity <= threshold && found.inventory_quantity > 0) {
      alertEl.style.display = 'none';
      alertTotalEl.style.display = 'none';
    } else if (found.inventory_quantity <= 0) {
      alertEl.style.display = 'none';
      alertTotalEl.style.display = 'none';
    } else {
      alertEl.style.display = 'none';
      alertTotalEl.style.display = 'none';
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// Nav Menu
// let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
//   items.forEach(item => {
//     item.addEventListener("mouseover", () => {
//       item.setAttribute("open", true);
//       item.querySelector("ul").addEventListener("mouseleave", () => {
//         item.removeAttribute("open");
//       });
//     item.addEventListener("mouseleave", () => {
//       item.removeAttribute("open");
//     });
//   });
// });

// Reviews Slider Homepage

var reviewsSection = document.querySelector('.reviews__section');

if (reviewsSection) {
  window.addEventListener('load', (event) => {
    if (window.innerWidth < 749) {
      var reviewsSlider = document.querySelector(
        '.reviews__section .reviews-wrap'
      );
      var flkty = new Flickity(reviewsSlider, {
        // options
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
      });
    }
  });

  window.addEventListener(
    'resize',
    function (event) {
      if (window.innerWidth < 749) {
        var reviewsSlider = document.querySelector(
          '.reviews__section .reviews-wrap'
        );
        var flkty = new Flickity(reviewsSlider, {
          // options
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false,
        });
      } else {
        flkty.destroy();
      }
    },
    true
  );
}

var hollowCollection = document.querySelector('.hollow-collection');

window.addEventListener('load', (event) => {
  if (!hollowCollection) {
    var logosSlider = document.querySelector('.logos-row-v2 .logos-wrap');
    if (window.innerWidth < 749 && logosSlider) {
      var logosFlkty = new Flickity(logosSlider, {
        // options for logos slider
        wrapAround: true,
        prevNextButtons: false,
        pageDots: true,
      });
    }
  }
});

window.addEventListener(
  'resize',
  function (event) {
    if (!hollowCollection) {
      var logosSlider = document.querySelector('.logos-row-v2 .logos-wrap');
      if (logosSlider) {
        if (window.innerWidth < 749) {
          var logosFlkty = new Flickity(logosSlider, {
            // options for logos slider
            wrapAround: true,
            prevNextButtons: false,
            pageDots: true,
          });
        } else {
          var logosFlkty = Flickity.data(logosSlider);
          if (logosFlkty) {
            logosFlkty.destroy();
          }
        }
      }
    }
  },
  true
);

// Quick Add Drop-Down for Product Cards

// window.addEventListener('DOMContentLoaded', () => {
//     const cards = document.querySelectorAll('.card-wrapper');

//     cards.forEach(async (card) => {
//       card.querySelector('.quick-add-title').addEventListener('click', (element) => {
//         console.log(card);
//         card.classList.toggle('quick-add-opened');
//       });
//     });
// });
